import { createEvent } from 'effector';

export const setActiveChatId = createEvent<number | null>();

export const getChats = createEvent();
